import api from 'common/api'

import { types } from '../../../../../AwesomeBar'
import ResultComponent from './ResultComponent'

export const label = 'Help'

export interface IHelpDocArticle {
  title: string
  url: string
  description: string
  categoryTitles: string[]
  tags: string[]
}

const onSearch = (term: string): Promise<{ articles: IHelpDocArticle[] }> => {
  return api.get(`/api/helpdocs/search?q=${encodeURIComponent(term)}`)
}

const getHelpResult = (article: IHelpDocArticle) => ({
  label: article.title,
  searchTypeLabel: label,
  url: article.url,
  description: article.description,
  categoryTitles: article.categoryTitles,
})

const search: (term: string) => Promise<unknown> = (term: string) => {
  return onSearch(term)
    .then((response) => (response?.articles ?? []).map(getHelpResult))
    .catch(() => [])
}

export const useHelpSearchConfig = (): types.ISearchConfiguration => {
  return {
    label,
    search,
    ResultComponent,
    allLimit: 5,
    placeholderOption: 'Search for help',
    // Disable HelpDocs in search until we find a better way to filter results
    hidden: true,
  }
}
